import React from 'react';
import AntdText from 'antd/es/typography/Text';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { tupleNum } from 'antd/es/_util/type';
import AntdConfigProvider from 'antd/es/config-provider';
const TEXT_LEVEL_LIST = tupleNum(1, 2, 3, 4);
const Text = (props) => {
    const { prefixCls: customizePrefixCls, className: customizeClassName, level = 1, ...restProps } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const className = classNames(`${prefixCls}-text-${level}`, customizeClassName);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', customizePrefixCls), ...restContext },
        React.createElement(AntdText, { ...restProps, prefixCls: prefixCls, className: className })));
};
export default Text;
